import React, { useState } from "react";
import { Link } from 'react-scroll';
import './Navbar.css'
import Hamburger from "hamburger-react";

function Navbar() {
    const [click, setClick] = useState(false);

    const handleClick = () => setClick(!click);
    return (
        <>
        <nav className="navbar">
            <div className="container">
                <div className="nav-content">
                  <Link to="/" className="nav-logo">
                    <img src="./images/logo.svg" alt="" />
                  </Link>
                    <div>
                        <div className={`nav-links ${click ? 'show-nav' : 'hide-nav'}`}>
                            <ul className="nav-menu">
                                <li className="nav-item">
                                <Link
                                    activeClass="active" 
                                    to="HeroSection" 
                                    spy={true} 
                                    smooth={true} 
                                    duration={500}  
                                    className="active nav-link"
                                    onClick={handleClick}
                                >
                                    Home
                                </Link>
                                </li>
                                <li className="nav-item">
                                <Link
                                    activeClass="active" 
                                    to="AboutUs" 
                                    spy={true} 
                                    smooth={true} 
                                    duration={500}
                                    className="active nav-link"
                                    onClick={handleClick}
                                >
                                    Who We Are
                                </Link>
                                </li>
                                <li className="nav-item">
                                <Link
                                    activeClass="active" 
                                    to="Services" 
                                    spy={true} 
                                    smooth={true} 
                                    duration={500}
                                    className="active nav-link"
                                    onClick={handleClick}
                                >
                                    Services
                                </Link>
                                </li>
                                <li className="nav-item">
                                <Link
                                    activeClass="active" 
                                    to="Commitment" 
                                    spy={true} 
                                    smooth={true} 
                                    duration={500}
                                    className="active nav-link"
                                    onClick={handleClick}
                                >
                                    Our Commitment
                                </Link>
                                </li>
                                <li className="nav-item">
                                <Link
                                    activeClass="active" 
                                    to="Faq" 
                                    spy={true} 
                                    smooth={true} 
                                    duration={500}
                                    className="active nav-link"
                                    onClick={handleClick}
                                >
                                    FAQs
                                </Link>
                                </li>
                            </ul>
                            <Link
                                activeClass="active" 
                                to="Contact" 
                                spy={true} 
                                smooth={true} 
                                duration={500}
                            >
                                <button className='btn nav-btn'
                                onClick={handleClick}
                                >Contact Us</button>
                            </Link>
                        </div>
                    </div>
                    <div className="nav-icon">
                      <Hamburger color="black" toggled={click} toggle={setClick} />
                    </div> 
              </div>
            </div>
        </nav>
        </>
    );
}

export default Navbar
